export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "securityMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your information is safe and secure."])}
    }
  })
}
